module.exports = __webpack_public_path__ + "img/new-era.8ffa62ad.jpg";